import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8262230"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "max-w-xl mx-auto p-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold text-center mb-6" }, "LLM Prompt Template Tool for Developers", -1))
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Please select one", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-slate-400" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "fill-current h-4 w-4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" })
  ])
], -1))
const _hoisted_8 = { class: "text-center mt-4" }
const _hoisted_9 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-semibold mb-2" }, "Final Text:", -1))
const _hoisted_11 = { class: "p-4 bg-slate-900 border border-slate-700 rounded-lg text-slate-300 overflow-x-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTemplate) = $event)),
          class: "block appearance-none w-full bg-slate-800 border border-slate-700 hover:border-slate-600 px-4 py-2 pr-8 rounded-lg shadow leading-tight focus:outline-none focus:shadow-outline text-slate-200 focus:ring-2 focus:ring-primary-500/50"
        }, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, (template) => {
            return (_openBlock(), _createElementBlock("option", {
              key: template.name,
              value: template
            }, _toDisplayString(template.name), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedTemplate]
        ]),
        _hoisted_7
      ]),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userInput) = $event)),
        placeholder: "Enter your original text or code here",
        class: "w-full p-3 mt-4 bg-slate-800 border border-slate-700 rounded-lg h-32 text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50"
      }, null, 512), [
        [_vModelText, _ctx.userInput]
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.generateFinalText && _ctx.generateFinalText(...args))),
          class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
        }, " Generate Final Text "),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearInputs && _ctx.clearInputs(...args))),
          class: "bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
        }, " Clear "),
        _createElementVNode("div", {
          class: _normalizeClass(["snackbar", { show: _ctx.showSnackbar }])
        }, "Copied to clipboard!", 2)
      ])
    ]),
    (_ctx.finalText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("pre", _hoisted_11, _toDisplayString(_ctx.finalText), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}